module.exports = __webpack_public_path__ + "img/img_assistant_img3.c8bd0890.png";